import { ds } from 'mewe/stores/ds';
import { later } from '@ember/runloop';
import EmberObject, { set } from '@ember/object';

export default {
  defaultErrorMessage: () => __(`We're sorry, something seems to have gone wrong. Please try again soon.`),

  message(message, type, action, options = {}) {
    if (!message) {
      console.error('Message is required for toast');
      return;
    }

    const duration = options.duration ?? 3000;

    const toastItem = EmberObject.create({
      id: Date.now(),
      message,
      type,
      action,
      duration,
      hasAction: !!action,
      questHint: message.questHint,
      showMessage: false,
      element: null,
      destroyToast: function() {
        if (this.isDestroyed || this.isDestroying) return;

        // in order to animate the toast hiding it needs to have defined height,
        // then the height is animated to 0 and the toast is removed
        if (this.element) {
          set(this, 'height', this.element.offsetHeight);
        }
        later(this, () => set(this, 'height', 0), 0);
        later(this, () => ds.toasterMessages.items.removeObject(this), 300);

        options.toastDestroyedCallback?.();
      }
    });

    // first push to render, then set flag for animated appearance
    ds.toasterMessages.items.pushObject(toastItem);
    later(() => { set(toastItem, 'showMessage', true) }, 10);

    options.toastAddedCallback?.(toastItem);

    // remove toast after duration,
    // if duration is set to 0 then toast should not disappear without user action
    if (toastItem.duration > 0) {
      later(() => { toastItem.destroyToast() }, toastItem.duration);
    }

    return toastItem;
  },

  hideMessage() {
    // just in case there were multiple messages for some reson we need to handle them all
    const noticeMsg = document.querySelectorAll(`#notices-msg`);
    noticeMsg.forEach((el) => {
      el.classList.add('fade-out');
    });

    // fade-out effect lasts for 1s
    setTimeout(() => {
      noticeMsg.forEach((el) => {
        const parent = el.parentNode;
        if (parent) parent.remove();
      });
    }, 1000);
  },

  attention(message) {
    this.message(message, 'attention');
  },

  error(message) {
    this.message(message, 'error');
  },

  info(message) {
    this.message(message, 'info');
  },

  notice(message) {
    this.message(message, 'notice');
  },

  err(message) {
    throw new Error(message);
  },

  handleGroupJoiningError(data = {}) {
    if (!data?.errorCode) this.error(this.defaultErrorMessage());

    switch (data.errorCode) {
      case 624:
        this.error(__('Sorry - you’re not allowed to join this group'));
        break;
      default:
        this.error(this.defaultErrorMessage());
        break;
    }
  },

  showDefaultErrorMessage() {
    this.error(this.defaultErrorMessage());
  },

  showLimitedPostingNotice() {
    this.message(
      __(
        `To keep MeWe's open groups safe from spammers, new members are not permitted to share links or images in open groups until after the first day they join. Thanks for your patience and understanding!`
      ),
      'notice',
      null,
      { duration: 15000 }
    );
  },

  showErrorRetryPost(action, options) {
    this.message(
      __(
        `This post could not be shared. Check your internet connection and <u id=\"error-action\">click to try again.</u>`
      ),
      'error',
      action,
      options
    );
  },

  showErrorRetryMessage(action, options) {
    this.message(
      __(`This message didn't send. Check your internet connection and <u id=\"error-action\">click to try again.</u>`),
      'error',
      action,
      options
    );
  },

  showErrorMaxCharacterLength() {
    this.error(__('Sorry, you have exceeded the character limit'));
  },
};
